/* eslint-disable */
import React, { useState } from "react";
import { alpha, styled } from "@mui/material/styles";
import {
  TreeItem,
  useTreeItem,
  TreeView,
} from "views/pages/manage/common/commonComponents/tree";
import CustomTreeItem from "./CustomTreeItem";
import { MinusSquare, PlusSquare, CloseSquare } from "./SvgIcon";
import { ReactComponent as HorizontalLine } from "../../../../../../assets/img/svg/HorizontalLine.svg";

const StyledTreeItem = styled((props) => (
  <TreeItem ContentComponent={CustomTreeItem} {...props} />
))(({ theme }) => ({
  // [`& .${treeItemClasses.group}`]: {
  //   marginLeft: 15,
  //   paddingLeft: 10,
  //   borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.2)}`,
  // },
}));

export default function SubjectTreeView({
  subjectChapters,
  setSubjectChapters,
  addHandler,
  expended,
  setExpended,
}) {
  const nodeMutator = (nodeData) => {
    switch (nodeData?.nodeType) {
      case "Chapter": {
        let temp = { ...subjectChapters };
        temp.tableOfContent.forEach((chapter) => {
          if (chapter.key === nodeData.key) {
            chapter["isAdded"] = true;
            addHandler(nodeData);
          }
        });
        setSubjectChapters(temp);
        break;
      }

      case "Topic": {
        let tempData = { ...subjectChapters };
        tempData.tableOfContent.forEach((chapter) => {
          if (chapter.key === nodeData.parentNode) {
            chapter["isAdded"] = true;
            chapter?.children.forEach((topic) => {
              if (topic.key === nodeData.key) {
                topic["isAdded"] = true;
                setExpended([...expended, nodeData.key.toString()]);
                addHandler(nodeData);
              }
            });
          }
        });
        setSubjectChapters(tempData);
        break;
      }

      case "Sub-Topic": {
        // topicParentId = chapter.key, parentNode = topic.key
        let tempSub = { ...subjectChapters };
        tempSub.tableOfContent.forEach((chapter) => {
          if (chapter.key === nodeData.topicParentId) {
            chapter["isAdded"] = true;
            chapter?.children.forEach((topic) => {
              if (topic.key === nodeData.parentNode) {
                topic["isAdded"] = true;
                topic?.children?.forEach((subtopic) => {
                  if (subtopic.key === nodeData.key) {
                    subtopic["isAdded"] = true;
                    addHandler(nodeData);
                  }
                });
              }
            });
          }
        });
        setSubjectChapters(tempSub);
        break;
      }

      case "Sub-Sub-Topic": {
        // chapterParentId = chapter.key, topicParentId = topic.key,
        // parentNode = subtopic.key, key = sub-sub-topic.key
        let temp = { ...subjectChapters };

        temp.tableOfContent.forEach((chapter) => {
          if (chapter.key === nodeData.chapterParentId) {
            chapter.isAdded = true;

            chapter.children?.forEach((topic) => {
              if (topic.key === nodeData.topicParentId) {
                topic.isAdded = true;

                topic.children?.forEach((subtopic) => {
                  if (subtopic.key === nodeData.parentNode) {
                    subtopic.isAdded = true;

                    subtopic.children?.forEach((subsub) => {
                      if (subsub.key === nodeData.key) {
                        subsub.isAdded = true;
                        addHandler(nodeData); // ✅ called only when exact key matched
                      }
                    });
                  }
                });
              }
            });
          }
        });

        setSubjectChapters(temp);
        break;
      }

      default:
        break;
    }
  };

  return (
    <TreeView
      aria-label="customized"
      defaultCollapseIcon={<MinusSquare />}
      defaultExpandIcon={<PlusSquare />}
      defaultEndIcon={<CloseSquare />}
      sx={{ height: "70vh", flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
    >
      {subjectChapters?.tableOfContent?.map((chapter, index) => {
        return (
          <StyledTreeItem
            key={chapter.key}
            nodeId={chapter.key.toString()}
            label={chapter.title}
            onClick={{ data: chapter, mutator: nodeMutator }}
          >
            {chapter.children?.map((topic) => {
              return (
                <StyledTreeItem
                  key={topic.key}
                  nodeId={topic.key.toString()}
                  label={topic.title}
                  onClick={{ data: topic, mutator: nodeMutator }}
                >
                  {topic?.children?.map((subtopic) => {
                    return (
                      <StyledTreeItem
                        key={subtopic.key}
                        nodeId={subtopic.key.toString()}
                        label={subtopic.title}
                        onClick={{
                          data: {
                            ...subtopic,
                            topicParentId: chapter.key,
                          },
                          mutator: nodeMutator,
                        }}
                        // Only force the dash icon when there are no children.
                        // If children exist, let the tree render +/- expand icons
                        // so Sub-Sub-Topics are reachable.
                        icon={
                          !subtopic?.children?.length ? (
                            <HorizontalLine />
                          ) : undefined
                        }
                      >
                        {/* ✅ NEW: render Sub-Sub-Topic level */}
                        {subtopic?.children?.map((subsubtopic) => {
                          return (
                            <StyledTreeItem
                              key={subsubtopic.key}
                              nodeId={subsubtopic.key.toString()}
                              label={subsubtopic.title}
                              onClick={{
                                data: {
                                  ...subsubtopic,
                                  // parentNode = subtopic.key (immediate parent)
                                  parentNode: subtopic.key,
                                  // topicParentId = topic.key
                                  topicParentId: topic.key,
                                  // chapterParentId = chapter.key
                                  chapterParentId: chapter.key,
                                },
                                mutator: nodeMutator,
                              }}
                              icon={<HorizontalLine />}
                            />
                          );
                        })}
                      </StyledTreeItem>
                    );
                  })}
                </StyledTreeItem>
              );
            })}
          </StyledTreeItem>
        );
      })}
    </TreeView>
  );
}
